/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Pace_Est_5kInputs */

const en_ui_pace_est_5k = /** @type {(inputs: Ui_Pace_Est_5kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5K`)
};

const de_ui_pace_est_5k = /** @type {(inputs: Ui_Pace_Est_5kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 km`)
};

/**
* | output |
* | --- |
* | "5K" |
*
* @param {Ui_Pace_Est_5kInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_pace_est_5k = /** @type {((inputs?: Ui_Pace_Est_5kInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pace_Est_5kInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_pace_est_5k(inputs)
	return de_ui_pace_est_5k(inputs)
});